export default __webpack_public_path__ + "static/media/2020-2.0b834879.jpeg";